import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../config/axios';

import UnidadeModal from './modals/Unidade';
import Paginacao from '../../../components/utils/paginacao';

import '../../../assets/styles/clientes.css';
import { FaPlus, FaEdit, FaFilter, FaArrowLeft } from 'react-icons/fa';
import Swal from 'sweetalert2';

const Unidades = () => {
  const { gestoraId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [gestora, setGestora] = useState(null);
  const [unidades, setUnidades] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroEmail, setFiltroEmail] = useState('');
  const [filtroCnpj, setFiltroCnpj] = useState('');

  const [selectedUnidade, setSelectedUnidade] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchGestora = async () => {
    try {
      const response = await api.get(`/gestoras/${gestoraId}`);
      setGestora(response.data);
    } catch (err) {
      navigate('/gestoras');
      setError('Erro ao carregar dados da gestora.');
    }
  };

  const fetchUnidades = async (currentPage) => {
    try {
      Swal.fire({
          title: "Carregando...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });

      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        email: filtroEmail,
        cnpj: filtroCnpj
      };

      const response = await api.get(`/gestoras/${gestoraId}/unidades`, { params });

      setUnidades(response.data.unidades || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchGestora();
  }, [gestoraId]);

  useEffect(() => {
    fetchUnidades(currentPage);    
  }, [currentPage, gestoraId]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddUnidade = () => {
    setSelectedUnidade(null);
    setIsModalOpen(true);
  };

  const handleEditUnidade = (unidade) => {
    setSelectedUnidade(unidade);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchUnidades(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroEmail('');
    setFiltroCnpj('');
  };

  const handleVoltarParaGestoras = () => {
    navigate('/gestoras');
  };

  const formatCnpj = (cnpj) => {
    if (!cnpj) return '';
    const cnpjStr = cnpj.toString();
    return cnpjStr.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12 d-flex align-items-center">
              <button 
                className="btn btn-outline-secondary me-3"
                onClick={handleVoltarParaGestoras}
                title="Voltar para Gestoras"
              >
                <FaArrowLeft />
              </button>
              <div>
                <h4 className="fw-bold mb-1">Unidades da Gestora</h4>
                {gestora && (
                  <p className="text-muted mb-0">{gestora.nome}</p>
                )}
              </div>
            </div>
          </div>
          
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddUnidade}>
                <FaPlus /> Adicionar Unidade
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome da unidade"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">E-mail</label>
              <input
                type="email"
                autoComplete="off"
                placeholder="Digite o e-mail"
                value={filtroEmail}
                className="form-control"
                onChange={(e) => setFiltroEmail(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">CNPJ</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o CNPJ"
                value={filtroCnpj}
                className="form-control"
                onChange={(e) => setFiltroCnpj(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="table-custom-primary">
                    <tr>
                      <th>Nome</th>
                      <th>Telefone</th>
                      <th>E-mail</th>
                      <th>CNPJ</th>
                      <th>Cidade</th>
                      <th>Status</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {unidades.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          Nenhuma unidade encontrada.
                        </td>
                      </tr>
                    ) : (
                      unidades.map((unidade) => (
                        <tr key={unidade.id}>
                          <td className="text-nowrap">{unidade.nome}</td>
                          <td className="text-nowrap">{unidade.telefone}</td>
                          <td className="text-nowrap">{unidade.email}</td>
                          <td className="text-nowrap">{formatCnpj(unidade.cnpj)}</td>
                          <td className="text-nowrap">{unidade.cidade}</td>
                          <td className="text-nowrap">
                            <span className={`badge ${unidade.ativo ? 'bg-success' : 'bg-secondary'}`}>
                              {unidade.ativo ? 'Ativo' : 'Inativo'}
                            </span>
                          </td>
                          <td className="text-nowrap text-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditUnidade(unidade)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <span>
              Total de registros: <strong>{totalRegistros}</strong>
            </span>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <UnidadeModal
            unidade={selectedUnidade}
            gestoraId={gestoraId}
            onClose={() => setIsModalOpen(false)}
            onUnidadeAtualizada={() => fetchUnidades(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Unidades; 